import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/user';
import 金融機関借入 from '@/entries/user/pages/authorized/事業所/計画書/分析計画/借入/金融機関借入/金融機関借入.vue';
import 役員借入 from '@/entries/user/pages/authorized/事業所/計画書/分析計画/借入/役員借入/役員借入.vue';
import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import TabsMixin from '@/mixins/TabsMixin';

export default mixins(RoutesMixin, TabsMixin).extend({
  name: 'P借入登録',

  components: {
    tab0: 金融機関借入,
    tab1: 役員借入,
    MoneyUnitSelect,
  },

  data(): {
    tabs: string[];
    eフェーズ種別: Eフェーズ種別;
  } {
    return {
      tabs: ['金融機関借入', '役員借入'],
      eフェーズ種別: Eフェーズ種別.分析フェーズ,
    };
  },
});
